// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 642 ? "94a7ad86" : chunkId) + "." + {"50":"75fa664512cd15c2","642":"711aff716151eaaf","741":"0c46b99e72663f69","970":"d26b95237c29aabd"}[chunkId] + ".js";
};